import type { RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: 'dashboard',
    name: 'dashboard',
    component: () => import('@/modules/dashboard/pages/dashboard-view.vue'),
    meta: {
      title: 'Dashboard - Workflow',
    },
  }
];

export default routes;